import { Component, Inject, Input } from '@angular/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatMenuModule } from '@angular/material/menu'
import { appNameToken, LogoAssets, logoAssetsToken } from 'shared-components'
import { NgOptimizedImage } from '@angular/common'
import { PlayToolbarLinksComponent } from '../play-toolbar-links/play-toolbar-links.component'
import { PlayHamburgerMenuComponent } from '../play-hamburger-menu/play-hamburger-menu.component'

@Component({
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    NgOptimizedImage,
    PlayToolbarLinksComponent,
    PlayHamburgerMenuComponent,
  ],
  selector: 'sans-play-toolbar',
  templateUrl: './play-toolbar.component.html',
  styleUrls: ['./play-toolbar.component.scss'],
})
export class PlayToolbarComponent {
  @Input() public gamePlayId = ''

  public constructor(
    @Inject(appNameToken) public readonly appName: string,
    @Inject(logoAssetsToken) public readonly logoAssets: LogoAssets,
  ) {}
}
